export default __webpack_public_path__ + "images/tj-b32f7c017787f0d8579b5aeab5923fb4.svg";